import React from 'react'
import clsx from 'clsx'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

export type StepperProps = {
  currentStep: number
  steps: {
    element: React.ReactNode
    isDisabled?: boolean
    isDone?: boolean
  }[]
}

const Stepper = ({ currentStep, steps }: StepperProps) => {
  return (
    <ol className="w-full space-y-3 overflow-hidden">
      {steps.map((step, index) => {
        const isDisabled = step?.isDisabled ?? index > currentStep
        const isDone = step?.isDone ?? index < currentStep

        return (
          <li
            key={index}
            className="relative flex-1 after:content-[''] after:w-0.5 after:h-full after:bg-gray-20 after:inline-block after:absolute after:-bottom-[calc(50%+14px)] after:left-[11px] after:last-of-type:h-0"
          >
            <div className="flex items-center w-full font-medium">
              <span
                className={clsx(
                  'flex items-center justify-center w-6 h-6 mr-3 text-sm text-white border-2 border-transparent rounded-full bg-blue-70',
                  isDone && 'bg-green-50',
                  isDisabled && 'bg-gray-20 text-subdued'
                )}
              >
                {isDone ? (
                  <Icon color="inverse" fontSize="sm" className="!cursor-auto">
                    check
                  </Icon>
                ) : (
                  <Text
                    color={isDisabled ? 'subdued' : 'inverse'}
                    variant="body-sm-bold"
                  >
                    {index + 1}
                  </Text>
                )}
              </span>
              <div className="block w-full">{step.element}</div>
            </div>
          </li>
        )
      })}
    </ol>
  )
}

export default Stepper
